/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { SpanLabel } from 'modules/ui/atoms/Typography/Label'
import RadioButtonContainer from './RadioButtonContainer'
import RadioButtonInput from './RadioButtonInput'

// Define the props for the radio button component
export interface RadioButtonProps {
  label?: string
  value?: string
  checked: boolean
  onChange: (...event: any[]) => void
  radioGroupName: string
  disabled?: boolean
  dataId?: string
  autoFocus?: boolean
  hasBorder?: boolean
}

// Define the radio button component
const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  value,
  checked,
  onChange,
  radioGroupName,
  disabled = false,
  dataId = '',
  autoFocus,
  hasBorder = true,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if ((event.key === 'Enter' || event.key === ' ') && !disabled) {
      event.preventDefault()
      onChange(value)
    }
  }

  return (
    <RadioButtonContainer
      checked={checked}
      disabled={disabled}
      hasBorder={hasBorder}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      role="radio"
      aria-checked={checked}
      aria-disabled={disabled}
    >
      <RadioButtonInput
        id={`radio-button-${value}`}
        type="radio"
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
        name={radioGroupName}
        tabIndex={0}
        data-id={dataId}
        autoFocus={autoFocus}
      />
      {label && <SpanLabel>{label}</SpanLabel>}
    </RadioButtonContainer>
  )
}

export default RadioButton
